import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import LineItem from './LineItem.react';
import PureComponent from 'lib/purecomponent';

export default class SubtopicList extends PureComponent {

  static propTypes = {
    subtopics: ImmutablePropTypes.list.isRequired
  }

  render() {
    if (this.props.subtopics.isEmpty()) {
      return null;
    }

    return (
      <ul className='guide-table-list-group'>
        {this.props.subtopics
          .map((subtopic) => {
            return (
              <LineItem
                key={subtopic.getId()}
                guideLevel={subtopic}
                indentLevel={3}
                storeName={`subtopic-${subtopic.getId()}-name-overflow-store`}
              />
            );
          })
        }
      </ul>
    );
  }
}
